export default function round(num) {
    return Math.ceil(num * 100) / 100;
}